import { render, staticRenderFns } from "./LoadingScreen.vue?vue&type=template&id=5177b26c&scoped=true"
import script from "./LoadingScreen.vue?vue&type=script&lang=ts"
export * from "./LoadingScreen.vue?vue&type=script&lang=ts"
import style0 from "./LoadingScreen.vue?vue&type=style&index=0&id=5177b26c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5177b26c",
  null
  
)

export default component.exports